import React from "react";

const StorefrontTitle = ({ title, desc }) => {
  return (
    <div className="storefront-title-container">
      <h2>{title}</h2>
      {desc ? <p>{desc}</p> : ""}
    </div>
  );
};

export default StorefrontTitle;
